import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { searchStore, SearchTotals, selectSearchParams } from '~/modules/stores/searchStore';
import { AI_OVERVIEW_SEARCH_ELEMENT_TYPE, AI_RELATED_SEARCH_SOURCE, AI_SEARCH_TYPE } from './aiSearchConstants';
import { GA4AiSearchEvent, GtmEventType } from './gtmEventType';
import { INLINE_SUGGESTION_SEARCH_SOURCE } from './gtmInlineSuggestionSearchType';

interface AiSearchEvent {
    topic: string;
    elementType: string;
    keyword?: string;
    totals?: Partial<SearchTotals>;
    aiSummaryResults?: number;
    aiSearchConversionAlreadyCounted?: boolean;
}

export class GtmAiSearchType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.aiSearchConversionAlreadyCounted !== true &&
            event.topic === AnalyticsEventTopic.ANALYTICS_SHOWN_IMPRESSION &&
            event.elementType === AI_OVERVIEW_SEARCH_ELEMENT_TYPE &&
            // Suppress related-search and inline-suggestion duplicates (W-23823546)
            selectSearchParams(searchStore.getState())?.searchSource !== AI_RELATED_SEARCH_SOURCE &&
            selectSearchParams(searchStore.getState())?.searchSource !== INLINE_SUGGESTION_SEARCH_SOURCE
        );
    }

    getBody(event: AiSearchEvent): GA4AiSearchEvent {
        const apps = event.totals?.apps || 0;
        const consultants = event.totals?.consultants || 0;
        const agents = event.totals?.agents || 0;
        const slack = event.totals?.slack || 0;
        const externalAgents = event.totals?.externalAgents || 0;

        return {
            event: 'custEv_search',
            search_term: event.keyword || '',
            search_type: AI_SEARCH_TYPE,
            search_category: 'all',
            search_result_count: apps + consultants + agents + slack + externalAgents,
            app_results: apps,
            consultant_results: consultants,
            agent_results: agents,
            // Salesforce platform = Apps, matching platformFilter.ts. Agents are a
            // `tech=force/copilot` subset of apps, so they are not added again here.
            salesforce_results: apps,
            slack_results: slack,
            ai_summary_results: event.aiSummaryResults || 0,
        };
    }
}
